// extracted by mini-css-extract-plugin
module.exports = {"label":"date_label__ilB4g font-bold inline-block mr-2","content":"date_content__NmNGP inline-block"};